import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromManagedStore from '../reducers/managed-store.reducers';

export const selectManagedStoreState = createFeatureSelector<fromManagedStore.ManagedStoreState>(
  fromManagedStore.managedStoreKey
);

export const selectManagedStoreList = createSelector(
  selectManagedStoreState,
  (state: fromManagedStore.ManagedStoreState) => state.managedStoreList
);
